<template>
	<div>
		<NavBar/>
		<Header />
		<router-view/>
		<Footer/>
	</div>
</template>
<script>
import NavBar from './components/NavBar.vue';
import Header from './components/Header.vue'
import Footer from './components/Footer.vue';

export default {
	name: "private",
	computed: {},
	components:{NavBar, Header, Footer },
	data() {
		return {
			banner: require("@/assets/images/customer/"+this.$store.state.customer+"/login-bg.jpg"),
			user: this.$auth.user(),
			asset_id: null,
			apartments: [],
			tab_index: 0,
			selectedApartment: null
		}
	},

	mounted() {
		if(this.$route.query.card_response)
			if(this.$route.query.card_response == "true"){
				this.$swal('Éxito!', 'Tarjeta Agregada con éxito', 'success')
			}else{
				this.$swal('Parace que hubo un error agregando tu tarjeta!', '', 'info')
			}
	},
	methods: {
		logout(){
			this.$auth.logout({
				redirect: '/login',
				success: function (msg) {
					console.error("LOGIN:",msg);
				},
			});
		}
	},
};
</script>
<style scoped>
</style>